import { ChangeEvent, KeyboardEvent, FC, useEffect, useState } from "react";
import DeviceConfig from "../config/Device.config";
import Device from "../interfaces/Device.interface";
import Usuario from "../interfaces/Usuario.interface";
import { toast, ToastContainer } from "react-toastify";
import colors from "../config/Colors.config";
import Block from "../components/Block.component";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, DropdownItem, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { AccountCircleOutlined, AddOutlined, AlternateEmailOutlined, ArrowBack, AssignmentIndOutlined, CachedOutlined, Close, ContactPageOutlined, DeleteOutlineOutlined, EmailOutlined, GppGoodOutlined, ImageOutlined, LocalPhoneOutlined, LockOpen, LockOutline, LockResetOutlined, PermIdentityOutlined, SaveOutlined, Search, VpnKeyOutlined } from "@mui/icons-material";
import { Tooltip } from "react-tooltip";
import Response from "../interfaces/Response.interface";
import UsuarioService from "../services/Usuario.service";
import DataTable, { TableColumn } from "react-data-table-component";
import { FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import UsuarioModel from "../models/Usuario.model";
import Numero from "../tools/Numero.tool";
import SelectStyle from "../assets/styles/Select.style";
import Image from "../tools/Imagen.tool";
import ComponentsTool from "../tools/Components.tool";
import Valor from "../interfaces/Valor.interface";
import TiempoTool from "../tools/Tiempo.tool";
import { Fade } from "react-awesome-reveal";

import imgNoImgUsuario from "../assets/img/imgNoImaUsuario.png";

let lastClickTime = 0;

const UsuarioView: FC<{ changeIndexPage: any, vUsuario: Usuario }> = ({ changeIndexPage, vUsuario }) => {

    const [data] = useState<Device>(DeviceConfig.data());

    const [texto, setTexto] = useState<string>("");

    const [usuario, setUsuario] = useState<Usuario>(UsuarioModel.getEstructura());
    const [arrayUsuarios, setAtrrayUsuarios] = useState<Usuario[]>([]);

    const [arrayStatusUsuario, setArrayStatusUsuario] = useState<Valor[]>([]);

    const [isOpenModalUsuario, setisOpenMOdalUsuario] = useState<boolean>(false);

    const [visible, setVisible] = useState<boolean>(false);
    const [correoValido, setCorreoValido] = useState<boolean>(false);

    const [modal, setModal] = useState<string>("Usuario");

    useEffect(() => {
        cargarPagina();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cambioUsuario = (name: string, value: string | number) => {
        setUsuario((prev: Usuario) => ({ ...prev, [name]: value }));
    }

    const cargarPagina = (): void => {
        usuariosListar();
        usuariosListarStatus();
    }

    const usuariosListar = async (): Promise<void> => {
        const response: Response = await UsuarioService.listar(texto);
        if (response.error === false) {
            const arrayUsuarios: Usuario[] = response.data.value;
            setAtrrayUsuarios(arrayUsuarios);
        }
    };

    const usuariosListarStatus = async (): Promise<void> => {
        const response: Response = await UsuarioService.listarStatus();
        if (response.error === false) {
            console.log(response.data.value)
            const arrayStatusUsuarios: Valor[] = response.data.value;
            setArrayStatusUsuario(arrayStatusUsuarios);
        }
    };

    const verDatosUsuario = (usuario: Usuario) => {
        setisOpenMOdalUsuario(true);
        setModal("Usuario");
        setUsuario(usuario);
    };

    const usuarioEliminar = async (IdUsuario: number): Promise<void> => {

    };

    const usuarioGuardar = async (): Promise<void> => {
        const response: Response = await UsuarioService.guardar(usuario);
        if (response.data.error === false) {
            const IdUsuario: number = response.data.value.IdUsuario ?? 0;
            setUsuario({ ...usuario, IdUsuario });
            usuariosListar();
            toast.success("Usuario guardado");
        }
    };

    const usuarioCambiarPassword = async (): Promise<void> => {

    };

    const validarCorreoRaiz = (email: string): boolean => {
        const regex = /^[^\s@]+@([a-zA-Z0-9-]+\.)*tzedaka\.com\.mx$/i;
        return regex.test(email);
    };


    const columnasUsuario: TableColumn<Usuario>[] = [
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <AccountCircleOutlined /> Nombre Completo</Label>,
            cell: (usuario: Usuario) => (
                <Label style={{ fontSize: 14, cursor: "pointer", fontWeight: "bold" }} onDoubleClick={() => verDatosUsuario(usuario)} >
                    {usuario.nombreCompleto} ({usuario.username})
                </Label>
            ),
            width: "40%"
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <GppGoodOutlined /> Estatus </Label>,
            cell: (usuario: Usuario) => (
                <Label style={{ fontSize: 14, cursor: "pointer", }} onDoubleClick={() => verDatosUsuario(usuario)} >
                    {usuario.estatus.valor}
                </Label>
            ),
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <EmailOutlined /> Correo Electrónico</Label>,
            cell: (usuario: Usuario) => (
                <Label style={{ fontSize: 14, cursor: "pointer", }} onDoubleClick={() => verDatosUsuario(usuario)} >
                    {usuario.correoElectronico.length === 0 ? <i>Dato faltante</i> : usuario.correoElectronico}
                </Label>
            ),
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <LocalPhoneOutlined /> Telefono</Label>,
            cell: (usuario: Usuario) => (
                <Label style={{ fontSize: 14, cursor: "pointer", }} onDoubleClick={() => verDatosUsuario(usuario)} >
                    {usuario.telefono.length === 0 ? <i>Dato faltante</i> : Numero.formatPhoneNumber(usuario.telefono)}
                </Label>
            ),
        },
        {
            name: <Label style={{ fontSize: 15, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} >  </Label>,
            cell: (usuario: Usuario) => (
                <IconButton
                    onDoubleClick={() => usuarioEliminar(usuario.IdUsuario)}
                    style={{ color: colors.rojo }}
                >
                    <DeleteOutlineOutlined />
                </IconButton>
            ),
        },
    ]

    return (
        <>

            <ToastContainer position="bottom-right" autoClose={5000} limit={3} />
            <main style={{ width: "100%", minHeight: "100vh", /*height:/* "100vh", maxHeight: "auto",*/ backgroundColor: colors.blanco }} >
                <section style={{ marginLeft: data.isDesktop ? 80 : 0, position: "relative" }} >
                    <Block height={"3vh"} />

                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <Col>
                            <Label style={{ fontSize: 24, fontWeight: "bold", color: colors.negro }} >
                                Usuarios <br />
                                <span style={{ fontWeight: "normal", fontSize: 14 }} >Administración y gestión de usuarios dados de alta en el sistema</span>
                            </Label>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <DropdownItem divider />
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <Col>
                            <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                <InputGroup >

                                    <Input
                                        id="login.username"
                                        name="username"
                                        type="text"
                                        placeholder=" "
                                        value={texto}
                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            setTexto(value);
                                        }}
                                        onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                            if (key === "Enter") usuariosListar();
                                        }}
                                        autoComplete="off"
                                    />
                                    <Label style={{ marginLeft: 0 }} >Nombre(s) o nombre de usuario</Label>
                                    <InputGroupText
                                        data-tooltip-id="tooltip-search-cliente"
                                        style={{ cursor: "pointer", color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                        onClick={() => usuariosListar()}
                                    >
                                        <Search />
                                    </InputGroupText>
                                    <Tooltip
                                        data-tooltip-id="tooltip-search-cliente"
                                        place="right-start"
                                    >
                                        <p>
                                            Buscar usuario
                                        </p>
                                    </Tooltip>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col style={{ textAlign: "right", }} >
                            <IconButton
                                style={{ marginTop: 25, marginRight: 10, color: colors.secundario }}
                                onClick={() => usuariosListar()}
                            >
                                <CachedOutlined />
                            </IconButton>
                            <IconButton
                                style={{ marginTop: 25, marginRight: 10, color: colors.secundario }}
                                onClick={() => {
                                    setUsuario(UsuarioModel.getEstructura());
                                    setisOpenMOdalUsuario(true);
                                }}
                            >
                                <AddOutlined />
                            </IconButton>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <Col>
                            <DataTable
                                columns={columnasUsuario}
                                data={arrayUsuarios}
                                highlightOnHover
                                customStyles={{
                                    rows: {
                                        highlightOnHoverStyle: {
                                            backgroundColor: "#eeeeee",
                                            transition: "0.3s",
                                            cursor: "pointer"
                                        },
                                    },
                                }}
                                onRowClicked={(row) => {
                                    const now = new Date().getTime();
                                    if (now - lastClickTime < 300) verDatosUsuario(row);
                                    lastClickTime = now;
                                }}
                            />
                        </Col>
                    </Row>
                </section>
            </main >

            <Modal
                isOpen={isOpenModalUsuario}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: modal === "Usuario" ? "60%" : "30%", transition: "min-width 1s ease" }}
                onOpened={() => {
                    setUsuario({ ...usuario, telefono: Numero.formatPhoneNumber(usuario.telefono) });
                    setCorreoValido(validarCorreoRaiz(usuario.correoElectronico));
                    setVisible(false);
                    TiempoTool.sleep(1).then(() => {
                        console.log("Vaciando")
                        if (usuario.correoElectronico.length === 0) setUsuario({ ...usuario, correoElectronico: "" });
                        if (usuario.passwordCorreoElectronico.length === 0) setUsuario({ ...usuario, passwordCorreoElectronico: "" })
                    });

                }}
                onClosed={() => setVisible(true)}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={

                        <Col style={{ textAlign: "right" }} >
                            {
                                modal === "Password" &&
                                <IconButton
                                    style={{ backgroundColor: colors.secundario, color: colors.blanco, marginRight: 10 }}
                                    onClick={() => setModal("Usuario")}
                                >
                                    <ArrowBack />
                                </IconButton>
                            }
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => {
                                    setisOpenMOdalUsuario(false);
                                    TiempoTool.sleep(0.750).then(() => {
                                        setModal("Usuario");
                                    });

                                }}
                            >
                                <Close />
                            </IconButton>

                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <AssignmentIndOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    {modal === "Usuario" ? "Dato del Usuario" : (usuario.IdUsuario === 0 ? "Crear Contraseña" : "Cambiar Contraseña")}
                                </span>
                                <small style={{ color: colors.blanco, fontSize: 13 }} >
                                    {usuario.username}
                                </small>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "60vh" : "", height: data.isDesktop ? "60vh" : "", maxHeight: data.isDesktop ? "60vh" : "", overflowY: "scroll" }} >
                    {
                        modal === "Usuario" &&
                        <div style={{ width: "100%", minHeight: "auto", height: "auto", backgroundColor: "", marginRight: 0, marginLeft: 0 }} >
                            <Fade>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ backgroundColor: "", minWidth: data.isDesktop ? "60%" : "100%", }} >
                                        <Card >
                                            <CardHeader>
                                                <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                    <ContactPageOutlined /> Informacion General
                                                </Label>
                                            </CardHeader>
                                            <CardBody>
                                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                                    <Col style={{ minWidth: data.isDesktop ? "100%" : "100%", width: data.isDesktop ? "100%" : "100%", maxWidth: data.isDesktop ? "100%" : "100%" }} >
                                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                                            <InputGroup >
                                                                <Input
                                                                    name="nombreCompleto"
                                                                    type="text"
                                                                    placeholder=" "
                                                                    value={usuario.nombreCompleto}
                                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                        cambioUsuario(name, value);
                                                                    }}
                                                                />
                                                                <Label style={{ marginLeft: 0 }} >Nombre Completo</Label>
                                                            </InputGroup>
                                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>Sin abreviaturas</span>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                                    <Col style={{ minWidth: data.isDesktop ? "100%" : "100%", width: data.isDesktop ? "100%" : "100%", maxWidth: data.isDesktop ? "100%" : "100%" }} >
                                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                                            <InputGroup >
                                                                <Input
                                                                    name="telefono"
                                                                    type="text"
                                                                    placeholder=" "
                                                                    value={usuario.telefono}
                                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                        value = Numero.soloNumeros(value)
                                                                        value = Numero.formatPhoneNumber(value);
                                                                        cambioUsuario(name, value);
                                                                    }}
                                                                />
                                                                <Label style={{ marginLeft: 0 }} >Numero de Telefono</Label>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                                    <Col>
                                                        <FormControl fullWidth style={{ marginTop: 10 }} >
                                                            <InputLabel
                                                                id="demo-simple-select-label"
                                                                sx={{
                                                                    color: colors.secundario,
                                                                    '&.MuiInputLabel-shrink': {
                                                                        fontSize: '1.2rem',
                                                                        color: colors.secundario
                                                                    },
                                                                }}
                                                            >
                                                                Estatus
                                                            </InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                style={{ borderRightColor: "transparent" }}
                                                                sx={SelectStyle.sx}
                                                                value={usuario.estatus.IdEstatus.toString()}
                                                                onChange={({ target: { value } }: SelectChangeEvent) => {
                                                                    setUsuario({ ...usuario, estatus: { ...usuario.estatus, IdEstatus: Number(value) } });
                                                                }}
                                                            >
                                                                <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                                {
                                                                    arrayStatusUsuario.map((item: Valor) => {
                                                                        return <MenuItem value={item.Id}> {item.valor} </MenuItem>
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Col>
                                                </Row>
                                                <Block height={30} />
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    {
                                        data.isDesktop &&
                                        <Col style={{ minWidth: "40%", borderRadius: 12 }} >
                                            <Card >
                                                <CardHeader>
                                                    <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                        <ImageOutlined /> Foto de Perfil
                                                    </Label>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                                        <Col style={{ minWidth: data.isDesktop ? "100%" : "100%", width: data.isDesktop ? "100%" : "100%", maxWidth: data.isDesktop ? "100%" : "100%" }} >

                                                            <img
                                                                data-tooltip-id="tooltip-img-usuario"
                                                                src={usuario.fotoPerfil.length === 0 ? imgNoImgUsuario : usuario.fotoPerfil}
                                                                alt="No imagen"
                                                                style={{ width: "100%", height: 250, cursor: "pointer", borderRadius: 30 }}
                                                                onClick={() => { ComponentsTool.click("input-img-usuario") }}
                                                            />
                                                            <input
                                                                type="file"
                                                                id="input-img-usuario"
                                                                style={{ display: "none" }}
                                                                accept="image/*"
                                                                onChange={async (e: ChangeEvent<HTMLInputElement>) => {
                                                                    const file = e.target.files?.[0];
                                                                    if (!file) return;
                                                                    const base64: string = await Image.convertirImagenABase64(file);
                                                                    setUsuario({ ...usuario, fotoPerfil: base64 })
                                                                }}
                                                            />
                                                            <Tooltip
                                                                id="tooltip-img-usuario"
                                                                place="bottom-end"
                                                            >
                                                                <p>
                                                                    {usuario.fotoPerfil.length === 0 ? "Agregar" : "Cambiar"} foto de perfil
                                                                </p>
                                                            </Tooltip>

                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col style={{ textAlign: "center" }} >
                                                            <Label
                                                                style={{ fontSize: 12, textDecorationLine: "underline", cursor: "pointer" }}
                                                                onClick={() => { ComponentsTool.click("input-img-usuario") }}
                                                            >
                                                                <i>{usuario.fotoPerfil.length === 0 ? "Agregar" : "Cambiar"} foto de perfil</i>
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    }

                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 15 }} >
                                    <Col style={{ backgroundColor: "", minWidth: data.isDesktop ? "100%" : "100%" }} >
                                        <Card >
                                            <CardHeader style={{ display: "flex", flexDirection: "column" }} >
                                                <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                    <AlternateEmailOutlined /> Correo Electronico
                                                </Label>
                                                <small style={{ marginLeft: 30 }} >
                                                    Al asociar un correo electrónico, el usuario podrá enviar mensajes a través del sistema.
                                                </small>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                                            <InputGroup >
                                                                <InputGroupText
                                                                    style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                                                >
                                                                    < EmailOutlined />
                                                                </InputGroupText>
                                                                <Input
                                                                    id="usuario.correoElectronico"
                                                                    name="correoElectronico"
                                                                    type="text"
                                                                    placeholder=" "
                                                                    value={usuario.correoElectronico}
                                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                        cambioUsuario(name, value);

                                                                        let tt: boolean = validarCorreoRaiz(value);
                                                                        console.log({ value, tt })
                                                                        setCorreoValido(tt);
                                                                    }}
                                                                    onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {

                                                                    }}
                                                                    autoComplete="off"
                                                                />
                                                                <Label style={{ marginLeft: 40 }} >Correo Electronico</Label>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                                            <InputGroup >
                                                                <InputGroupText
                                                                    style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                                    onClick={() => setVisible(!visible)}
                                                                >

                                                                    {visible ? <LockOpen /> : <LockOutline />}
                                                                </InputGroupText>
                                                                <Input
                                                                    id="logiusuarion.passwordCorreoElectronico"
                                                                    name="passwordCorreoElectronico"
                                                                    type={visible ? "text" : "password"}
                                                                    placeholder=" "
                                                                    value={usuario.passwordCorreoElectronico}
                                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                        cambioUsuario(name, value);
                                                                    }}
                                                                    onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {

                                                                    }}
                                                                    autoComplete="off"
                                                                />
                                                                <Label style={{ marginLeft: 40 }} >Contraseña</Label>
                                                                <InputGroupText
                                                                    style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                                    onClick={() => setVisible(!visible)}
                                                                >
                                                                    {visible ? "Ocultar" : "Mostrar"}
                                                                </InputGroupText>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            {
                                                (usuario.correoElectronico.length > 0 && !correoValido) &&
                                                <Fade direction="down" duration={750} >
                                                    <CardFooter>
                                                        <i style={{}} >
                                                            Para habilitar el envío de correos desde el sistema, se requiere una cuenta de correo con dominio @tzedaka.com.mx
                                                        </i>
                                                    </CardFooter>
                                                </Fade>
                                            }
                                        </Card>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 15 }} >
                                    <Col style={{ backgroundColor: "", minWidth: data.isDesktop ? "100%" : "100%" }} >
                                        <Card >
                                            <CardHeader>
                                                <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                                    <VpnKeyOutlined /> Informacion de LogIn
                                                </Label>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                                            <InputGroup >
                                                                <InputGroupText
                                                                    style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                                                >
                                                                    <PermIdentityOutlined />
                                                                </InputGroupText>
                                                                <Input
                                                                    id="login.username"
                                                                    name="username"
                                                                    type="text"
                                                                    placeholder=" "
                                                                    value={usuario.username}
                                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                        cambioUsuario(name, value);
                                                                    }}
                                                                    onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {

                                                                    }}
                                                                    autoComplete="off"
                                                                />
                                                                <Label style={{ marginLeft: 40 }} >Nombre de Usuario</Label>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            style={{ width: "100%", backgroundColor: colors.blanco, fontWeight: "bold", boxShadow: "none", marginTop: 27, color: colors.secundario, borderColor: colors.secundario }}
                                                            onClick={() => {
                                                                setModal("Password");
                                                                TiempoTool.sleep(0.750).then(() => {
                                                                    setUsuario(({ ...usuario, password: "" }));
                                                                });
                                                            }}
                                                        >
                                                            <LockResetOutlined /> {usuario.IdUsuario === 0 ? "Crear contraseña" : "Cambiar contraseña"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Fade>
                        </div>
                    }
                    {
                        modal === "Password" &&
                        <Fade>
                            <Row style={{ marginRight: 0, marginLeft: 0, width: "100%" }} >
                                <Col>
                                    <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                        <InputGroup >
                                            <InputGroupText
                                                style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                onClick={() => setVisible(!visible)}
                                            >

                                                {visible ? <LockOpen /> : <LockOutline />}
                                            </InputGroupText>
                                            <Input
                                                name="password"
                                                type={visible ? "text" : "password"}
                                                placeholder=" "
                                                value={usuario.password}
                                                style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                    cambioUsuario(name, value);
                                                }}
                                                onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {

                                                }}
                                                autoComplete="off"
                                            />
                                            <Label style={{ marginLeft: 40 }} >Nueva Contraseña</Label>
                                            <InputGroupText
                                                style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                onClick={() => setVisible(!visible)}
                                            >
                                                {visible ? "Ocultar" : "Mostrar"}
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 15 }} >
                                <Col style={{ textAlign: "right" }} >
                                    <Button
                                        style={{ backgroundColor: colors.secundario, color: colors.blanco, boxShadow: "none", width: 100, fontWeight: "bold" }}
                                        onClick={() => {
                                            usuarioCambiarPassword();
                                            setModal("Usuario");
                                            TiempoTool.sleep(1).then(() => {
                                                console.log("Vaciando")
                                                if (usuario.correoElectronico.length === 0) setUsuario({ ...usuario, correoElectronico: "" });
                                                if (usuario.passwordCorreoElectronico.length === 0) setUsuario({ ...usuario, passwordCorreoElectronico: "" })
                                            });
                                        }}
                                    >
                                        Listo
                                    </Button>
                                </Col>
                            </Row>
                        </Fade>
                    }


                </ModalBody >
                <ModalFooter>
                    {
                        usuario.IdUsuario > 0 &&
                        <Button
                            style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.blanco, color: colors.rojo, borderColor: colors.rojo, fontWeight: "bold", boxShadow: "none" }}
                            onClick={() => setisOpenMOdalUsuario(false)}
                        >
                            <DeleteOutlineOutlined /> Eliminar
                        </Button>
                    }

                    <Button
                        style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => usuarioGuardar()}
                    >
                        <SaveOutlined /> {data.isDesktop ? "Guardar" : ""}
                    </Button>
                </ModalFooter>
            </Modal >

        </>
    )

};

export default UsuarioView
